import {
  BanknotesIcon,
  CalendarDaysIcon,
  QrCodeIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline";
import GeneralInfoForm from "../../pages/Drivers/GeneralInfoForm";
import PartnerEarningsTab from "./partner/PartnerEarningsTab";
import PartnerQrTab from "./partner/PartnerQrTab";
import PartnerReservationsTab from "./partner/PartnerReservationsTab";
import PillTabs, { PillTab } from "./PillTabs";

const TABS: PillTab[] = [
  { key: 0, label: "Informations générales", icon: UserCircleIcon },
  { key: 1, label: "Revenus", icon: BanknotesIcon },
  { key: 2, label: "QR & Flyers", icon: QrCodeIcon },
  { key: 3, label: "Réservations", icon: CalendarDaysIcon },
];

export function PartnerDetailNav({
  activeTab,
  onTabChange,
}: {
  activeTab: number;
  onTabChange: (tab: number) => void;
}) {
  return (
    <PillTabs tabs={TABS} activeTab={activeTab} onTabChange={onTabChange} />
  );
}

export function PartnerDetailContent({
  activeTab,
  userData,
  invalidateQuery,
}: {
  activeTab: number;
  userData: User;
  invalidateQuery: () => void;
}) {
  return (
    <>
      {activeTab === 0 && (
        <GeneralInfoForm
          data={userData}
          role="user"
          invalidateQuery={invalidateQuery}
        />
      )}
      {activeTab === 1 && <PartnerEarningsTab partnerId={userData.id} />}
      {activeTab === 2 && <PartnerQrTab user={userData} />}
      {activeTab === 3 && <PartnerReservationsTab partnerId={userData.id} />}
    </>
  );
}
